import {useCallback} from 'react';

import {useDocumentUtils} from '@/components/document/utils';
import {SUMMARY_SECTION} from '@/constants/sections';
import {DocumentModel} from '@/engine/types/document-model/document-model';
import {DocumentContextType} from '../document-context';

type Props = {
  formSectionId: string;
  nextSectionId: string | null;
  setCurrentSectionId: DocumentContextType['setCurrentSectionId'];
  documentModel: DocumentModel;
  saveChanges: () => Promise<void>;
};

export const useSubmitSection = ({
  formSectionId,
  nextSectionId,
  documentModel,
  setCurrentSectionId,
  saveChanges,
}: Props) => {
  const {store, valueResolver} = useDocumentUtils();

  return useCallback(async () => {
    const isValid = store.getState().validateSection(formSectionId, {documentModel, valueResolver});

    if (!isValid) return;

    const submitActions = documentModel.sections.find(section => section.id === formSectionId)?.onSubmit ?? [];

    for (const action of submitActions) {
      if ((await action()) === false) return;
    }

    saveChanges();

    if (nextSectionId) {
      setCurrentSectionId(nextSectionId);
    } else {
      setCurrentSectionId(SUMMARY_SECTION);
    }
  }, [store, formSectionId, nextSectionId, documentModel, valueResolver, saveChanges, setCurrentSectionId]);
};
